import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getLifeDateFormatted } from '../fun/getLifeDateFormatted'
import { getPersonAgeFormatted } from '../fun/getPersonAgeFormatted'
import { getPersonIdFromUrl } from '../fun/getPersonIdFromUrl'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { isDead } from '../fun/isDead'
import { _ } from '../model/ccc'
import type { IPerson } from '../model/IPerson'
import { PortraitComp } from './PortraitComp'

export const PersonLinkComp = defineComponent<{ get: () => IPerson }>(
	'PersonLinkComp',
	({ get: getPerson }, $) => {
		const data = getDataOrThrow()

		return (
			<a
				class={() => [
					_.ccc_button__person,
					getPerson().id === getPersonIdFromUrl() && _.ccc__selected,
				]}
				href={() => url`/person/${getPerson().id}`}
			>
				<PortraitComp getPerson={getPerson} />
				<div>
					<Slot get={() => getPersonNameFormatted(data, getPerson())} />
					<div class={_.ccc_date}>
						<Slot
							get={() =>
								getLifeDateFormatted({
									data,
									isYearOnly: true,
									person: getPerson(),
								})
							}
						/>{' '}
						–{' '}
						<Slot
							get={() =>
								isDead(data, getPerson())
									? getLifeDateFormatted({
											data,
											isYearOnly: true,
											isDeath: true,
											person: getPerson(),
										})
									: getPersonAgeFormatted(getPerson())
							}
						/>
					</div>
				</div>
			</a>
		)
	},
)
